// extracted by mini-css-extract-plugin
export default {"root":"StarRating-root-1144ed718fa0f8a1ee8ab41d13a376fd"};